// import { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { TabMenu } from 'primereact/tabmenu';
// import { MenuItem } from 'primereact/menuitem';

// export const ApplicationTab = (mainTabLabel: any) => {

//     const router = useNavigate();

//     const assignedMenu: any = localStorage.getItem('assigned_menu') ? localStorage.getItem('assigned_menu') : '';

//     const HRitems: MenuItem[] = [
//         {
//             label: 'Fresh Application',
//             command: () => {
//                 router('/app/application/fresh-registration-list');
//             }
//         },
//         {
//             label: 'Renew/Re-Entry Application',
//             command: () => {
//                 router('/app/application/renew-application');
//             }
//         },
//         {
//             label: 'Election Application',
//             command: () => {
//                 router('/app/application/electoral');
//             }
//         },
//         {
//             label: 'Other Application',
//             command: () => {
//                 router('/app/application/address-change');
//             }
//         }
//     ];
//     const [activeIndex, setActiveIndex] = useState<number>(0);

//     // Convert string to Set
//     const assignedMenuSet = new Set(assignedMenu.split(',').map((item: string) => item.trim()));

//     // Filter HRitems by checking if label exists in assignedMenuSet
//     const filteredHRitems = HRitems.filter((item) => item.label && assignedMenuSet.has(item.label));

//     useEffect(() => {
//         if (filteredHRitems.length > 0 && mainTabLabel) {
//             const foundIndex = filteredHRitems.findIndex((item) => item.label == mainTabLabel.mainTabLabel);
//             setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
//         }
//     }, [filteredHRitems]);

//     return (
//         <>
//             <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab" />
//         </>
//     );
// };

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';

export const ApplicationTab = ({ mainTabLabel }: { mainTabLabel: string }) => {
    const router = useNavigate();
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const assignedMenu = localStorage.getItem('assigned_menu') || '';
    const assignedActions = localStorage.getItem('assigned_actions');
    const parsedActions = assignedActions ? JSON.parse(assignedActions) : [];

    const subMenus = [
        {
            label: 'Fresh Application',
            items: [
                { label: 'Fresh Registration', to: '/app/application/fresh-registration-list' },
                { label: 'Fresh Registration Other', to: '/app/application/fresh-registration-other-list' },
                { label: 'Fresh Registration (Transfer To Gujarat)', to: '/app/application/fresh-registration-transfer-list' },
                { label: 'Transfer DD/DNH', to: '/app/application/fresh-registration-transfer-list-diu-daman/QWxs' },
                { label: 'Eligible Application (Maharashtra State)', to: '/app/application/eliglible-application-list' },
                { label: 'Eligible Application (Other)', to: '/app/application/eliglible-application-other-list' }
            ]
        },
        {
            label: 'Renew/Re-Entry Application',
            items: [
                { label: 'Renew Application', to: '/app/application/renew-application' },
                { label: 'Re-Entry Application', to: '/app/application/re-entry' }
            ]
        },
        {
            label: 'Election Application',
            items: [
                { label: 'Electoral Roll Fees Application', to: '/app/application/electoral' },
                { label: 'Election Deposit Application', to: '/app/application/election-deposit' },
                { label: 'Nomination Form Fees', to: '/app/application/nomination-fees-form' }
            ]
        },
        {
            label: 'Other Application',
            items: [
                { label: 'Address Change', to: '/app/application/address-change' },
                { label: 'Name Change', to: '/app/application/name-change' },
                { label: 'Good Standing Application', to: '/app/application/goodstanding-application-list' },
                { label: 'Duplicate Cerificate', to: '/app/application/duplicate-certificate-application-list' },
                { label: 'Registration Cancellation', to: '/app/application/registration-cancellation' },
                { label: 'Degree Additional', to: '/app/application/degree-addition' },
                { label: 'Provisional To Original', to: '/app/application/pro-to-org-application' },
                { label: 'Penalty', to: '/app/application/penlty' },
                { label: 'Penalty Under Jan Vishwas', to: '/app/application/penalty-jan-vishwas' },
                { label: 'Search', to: '/app/application/search' }
            ]
        }
    ];

    // Set for fast lookup
    const assignedMenuSet = new Set(assignedMenu.split(',').map((item: string) => item.trim()));

    // Check access logic like main menu function
    const getFirstAccessibleSubItem = (tabLabel: string): string | null => {
        const subGroup = subMenus.find((group) => group.label === tabLabel);
        if (!subGroup) return null;

        const action = parsedActions.find((a: any) => a.menu === tabLabel);
        if (!action) return null;

        for (const subItem of subGroup.items) {
            if (typeof action === 'object' && action[subItem.label] === 1) {
                return subItem.to;
            }
        }
        return null;
    };

    // Build TabMenu model dynamically
    const filteredHRitems: MenuItem[] = subMenus
        .filter((group) => assignedMenuSet.has(group.label))
        .map((group) => {
            const firstAccessible = getFirstAccessibleSubItem(group.label);
            return {
                label: group.label,
                command: () => {
                    if (firstAccessible) {
                        router(firstAccessible);
                    }
                }
            };
        });

    // Set active tab
    useEffect(() => {
        if (filteredHRitems.length > 0 && mainTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label === mainTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [filteredHRitems]);

    return <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab" />;
};
